import { render, staticRenderFns } from "./SavingAnimation.vue?vue&type=template&id=4606a7ec&scoped=true&"
import script from "./SavingAnimation.vue?vue&type=script&lang=js&"
export * from "./SavingAnimation.vue?vue&type=script&lang=js&"
import style0 from "./SavingAnimation.vue?vue&type=style&index=0&id=4606a7ec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4606a7ec",
  null
  
)

export default component.exports